import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <a href="#comprar" className={`inline-block cta-pulse bg-[#FFD700] hover:bg-[#FFC107] text-black font-black text-xl md:text-2xl py-5 px-10 rounded-xl shadow-[0_0_30px_rgba(255,215,0,0.4)] transition-colors text-center uppercase tracking-wide border-b-4 border-yellow-600 active:border-b-0 active:translate-y-1 ${className}`} data-id="element-18">
      {children}
    </a>;
}